import { createStyles, makeStyles, Theme } from '@material-ui/core';

export interface LabelsPageStylesProps {}

export const useStyles = makeStyles<Theme, LabelsPageStylesProps>((theme: Theme) =>
    createStyles({
        container: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            minHeight: "50vh",
            padding: "7.5rem",
            boxSizing: "border-box",
            [theme.breakpoints.down("md")]: {
                padding: "5rem",
            },
            [theme.breakpoints.down("sm")]: {
                padding: "3rem",
            },
            [theme.breakpoints.down("xs")]: {
                padding: "2rem",
            },
        },
        rotate: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transform: "rotate(90deg)",
            transformOrigin: "center center",
        },
        label: {
            display: "block",
            width: "50%",
            maxWidth: "70vw",
            maxHeight: "70vh",
            height: "auto",
            margin: "0 auto",
            objectFit: "contain",
            [theme.breakpoints.down("md")]: {
                width: "60%"
            },
            [theme.breakpoints.down("sm")]: {
                width: "80%"
            },
            [theme.breakpoints.down("xs")]: {
                width: "100%"
            }
        },

    }),
);